// extracted by mini-css-extract-plugin
module.exports = {"valueStyle":"_8T6GXZW48l7spsZq2I835"};